export default "__VITE_ASSET__a8ba5712__"